import { FC } from 'react'
import styled from 'styled-components'
import { Button } from 'shared/components/Button'
import FormikInput from 'shared/components/Input/FormikInput'
import EditSection from './EditSection'
import { media } from 'shared/lib'
import ContextErrorBanner from 'errors/components/ContextErrorBanner'
import { AccountQA } from 'shared/dataAttributes'
import { t } from 'localization'

const TP = 'account.components.editAccount'

const EditAccountInput = styled(FormikInput)`
  margin: 15px 0;
`
const ChangePasswordButton = styled(Button)`
  width: 100%;
  display: inline-block;
  text-align: center;
  ${media.large`
    height: 30px;
    line-height: 30px;
    width: 155px;
  `}
`

const EditAccount: FC = () => {
  return (
    <>
      <EditSection qaAttr={AccountQA.EditUsernameSection} title={t(`${TP}.username`, 'Username')}>
        <ContextErrorBanner qaAttr={AccountQA.EditErrorTopForm} />
        <EditAccountInput
          data-testid="name-input"
          qaAttr={AccountQA.EditFullnameBox}
          title={t(`${TP}.fullName`, 'Full Name')}
          name="fullName"
          type="text"
          autoComplete="name"
        />
      </EditSection>
      <EditSection qaAttr={AccountQA.EditPasswordSection} title={t(`${TP}.password`, 'Password')}>
        <ChangePasswordButton
          href="/customer/account/forgotpassword"
          data-qa={AccountQA.EditChangePasswordButton}
          component="span"
          buttonType="secondary"
        >
          {t(`${TP}.changePassword`, 'Change Password')}
        </ChangePasswordButton>
      </EditSection>
    </>
  )
}

export default EditAccount
